/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import EditableText from 'material/embeds/editabletext/editabletext_container';
import Delete from 'material/embeds/content/edit/delete/delete_container';
import Correct from 'material/embeds/content/edit/correct/correct_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/answer/text1/text1_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : TEXT 1 ~~~~~~~~~~ ========== */
class AnswerText1 extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: false, fontSize: 'standard' };
        this.characterLimit = 32;
        this.answerEl = null;
        this.availableSizes = ['standard', 'medium', 'large'];
    }

    componentWillMount() {
        this.validateText(this.props.text, true)
    }

    componentDidUpdate(prevProps) {
        if(this.props.text !== null && prevProps.text !== null && (prevProps.text.length !== this.props.text.length)) this.validateText(this.props.text, false
        );
    }

    handleSelect = (text) => {
        this.validateText(text, false);
        this.setState({
            selected: !this.state.selected
        });
    };

    adjustFontSize = () => {
        let ansSize = this.state.fontSize;
        const currAnsSizeIndex = this.availableSizes.indexOf(ansSize);
        if (this.answerEl && (this.getContainerDimensions().height - this.getElementInContainerDimensions().height) < 0 && ansSize !== 'large' ) {
            window.answerEl = this.answerEl;
            ansSize = this.availableSizes[currAnsSizeIndex + 1] ? this.availableSizes[currAnsSizeIndex + 1] : ansSize;
            this.setState({
                fontSize: ansSize
            }, () => this.adjustFontSize()); // again calling it just in case to see if fonts need more readjustment. Wont be called unless font needs resizing.
        }
    };

    getContainerDimensions() {
        const el = this.answerEl;
        let height = el.clientHeight;
        return { width: el.clientWidth, height: height };
    }

    getElementInContainerDimensions() {
        const el = this.answerEl.firstChild;
        return { width: el.clientWidth, height: el.clientHeight };
    }

    handleKeyUp = text => this.validateText(text, false);

    validateText = (text, isInitialValidation=false) => {
        const trimmedText = (text !== null) ? text.trim(): '';
        if(trimmedText.length > this.characterLimit) { return null; }
        const isValid = this.props.isValid;

        if (trimmedText.length === 0 && (isValid || isValid === null)) {
            const valid = trimmedText !== '';
            if(!isInitialValidation && trimmedText !== null) this.setIsValidStateProperty(valid)
        } else if (trimmedText.length > 0 && !isValid) {
            this.setIsValidStateProperty(true)
        }

        // TODO: Remove this logic from the validation method
        if (trimmedText.length > 0) {
            this.setState({
                fontSize: 'standard'
            }, () => this.adjustFontSize());
            this.adjustFontSize();
        }
    };

    setIsValidStateProperty(isValid) {
        if(isValid !== this.props.isValid) this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', isValid)
    }

    render() {
        const placeholderText = 'Type answer...'; // this should come from redux
        return(
            <div className={`text1 ${this.props.classes.text1}`}>
                <span className={`background selected-${this.state.selected} valid-${this.props.isValid} duplicate-${this.props.isDuplicate}`}><span className={`overlay`}/></span>
                <span className={`icon`} />
                <span ref={span => this.answerEl = span} className={`text ${this.state.fontSize}`}>
                    <EditableText
                        key={`${this.props.isEditable ? `editor` : `card`}-option-${this.props.contentId}${this.props.optionId}`}
                        contentId={this.props.contentId}
                        textValue={null}
                        isOption={true}
                        textType={'text1'}
                        optionId={this.props.optionId}
                        placeholderText={placeholderText}
                        isEditable={this.props.isEditable}
                        onFocus={this.handleSelect}
                        onBlur={this.handleSelect}
                        onKeyUp={this.handleKeyUp}
                        preventEnter={true}
                        characterLimit={this.characterLimit}
                    />
                </span>
                <Delete contentId={this.props.contentId} optionId={this.props.optionId} position={`top right`} />
                <Correct contentId={this.props.contentId} optionId={this.props.optionId} type={`text1`} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AnswerText1);
